export type Datepicker = Date | string;
export enum DatepickerViewMode {
  day = 'day',
  month = 'month',
  year = 'year'
}
